import React, { useEffect, useState } from 'react';
import { SignalViewer, TherapyDayData, TherapyTimeInterval } from '@lmt/signal-viewer-ui';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { QueryFactory } from '@lmt/shared-types';
import { Loading } from '@lmt/unicorn-shared/app/components/common/Loading';
import { ChannelSpecs } from '@lmt/unicorn-shared/app/components/signal-viewer/channel-templates';

export const SignalViewerPage: React.FC = () => {
  const documentQuery = QueryFactory.FileQuery.useDownloadFileQuery({
    fileId: pages.signalViewer.useParams().documentId,
  });

  const [therapyData, setTherapyData] = useState<TherapyDayData|null>(null);
  useEffect(() => {
    let cancelled = false;

    const processData = () => {
      if (therapyData !== null || !documentQuery.data) return;

      const signalsArray = documentQuery.data.data;
      if (!cancelled) {
        setTherapyData({
          events: '',
          signals: signalsArray,
        });
      }
    };

    processData();

    return () => {
      cancelled = true;
    };
  }, [documentQuery.data, therapyData]);

  const isLoading = documentQuery.isLoading;
  if (!therapyData) return <Loading loading={isLoading} title="Loading" />;

  return (
    <SignalViewer
      data={therapyData}
      size={{ height: 700, width: 1200 }}
      enableResize={false}
      providedConfigs={ChannelSpecs}
      therapyTimeInterval={TherapyTimeInterval.FromMidday24Hours}
    />
  );
};

